import { registerGame } from '../../../game/framework/GamesRegistry';
import { BookOpen } from 'lucide-react';

registerGame({
  id: 'koumori-sensei',
  displayName: 'Koumori Sensei',
  shortDescription: 'Interactive Japanese & Kanji learning game activity.',
  category: 'educational',
  multiplayer: false,
  available: true,
  leaderboard: 'score',
  icon: BookOpen,
  asset: async () => ({ default: () => null }),
  attribution: {
    text: 'Koumori Sensei — Kanji Cave',
    license: 'Web Application',
    href: 'https://kanji-cave.pages.dev/',
  },
});
